"use strict"

import React, { useRef, useState } from "react"
import { Button } from "react-bootstrap"
import { FormattedMessage, useIntl } from "react-intl"

import { indirectUploadFile } from "../../Loaders"
import { logToServer } from "../../ErrorBoundary"

export default function UploadData(props) {
  const intl = useIntl()
  const { file_type, process_now, refresh_data, submit_file, on_upload_fail, params } = props
  const [file, setFile] = useState(null)
  const [uploadErr, setUploadErr] = useState(false)
  const inputRef = useRef()

  const handleFileUpload = (e, setFile) => {
    e.preventDefault()
    setUploadErr(false)
    if (e.target.files.length > 0) {
      setFile(e.target.files[0])
    }
  }

  const submitFileUpload = (e, file) => {
    e.preventDefault()

    if (file) {
      submit_file ? submit_file() : null

      let formData = new FormData()
      formData.append("file", file)
      if (props.metadata) {
        formData.append("metadata", JSON.stringify(props.metadata))
      }

      indirectUploadFile(formData, file_type, process_now, params)
        .then(() => {
          if (inputRef.current) {
            inputRef.current["value"] = null
          }
          setFile(null)
          setUploadErr(false)
          refresh_data ? refresh_data() : null
          alert(intl.formatMessage({ id: "general.file.uploaded" }))
        })
        .catch((error) => {
          on_upload_fail ? on_upload_fail() : null
          setUploadErr(true)
          logToServer(error)
          alert(intl.formatMessage({ id: "general.file.upload.failed" }))
        })
    }
  }

  return (
    <div align={"center"} className={"dashed-grey-border"} style={{ padding: "30px", marginTop: "10px" }}>
      {uploadErr && (
        <div style={{ marginBottom: "15px" }} className={"error-message"}>
          *
          <FormattedMessage id={"general.file.upload.failed"} description={"Upload failed message"} />
        </div>
      )}
      <div>
        <input
          type={"file"}
          style={{ margin: "auto" }}
          multiple={false}
          accept={".csv"}
          ref={inputRef}
          onChange={(e) => handleFileUpload(e, setFile)}
        />
      </div>
      <Button
        variant={"primary"}
        size={"sm"}
        style={{ marginTop: "10px" }}
        onClick={(e) => submitFileUpload(e, file)}
      >
        <span className={"fa fa-arrow-circle-o-up text_white"} />
        &nbsp;&nbsp;
        <FormattedMessage id={"general.upload"} description={"File Upload Button"} />
      </Button>
    </div>
  )
}
